<template>
    <div v-if="!error" class="block">
        <!-- FILTRES FOR NOT MOBILE -->
        <div v-if="!$store.state.isMobile" class="row filters">
            <div class="col-12 col-lg-6 col-xl-4 name_input">
                <input v-model="filters.q" class="form-control name_input" placeholder="Vyhledat podle názvu nebo IČO">
            </div>
            <div class="col-12 col-lg-6 col-xl-4 mt-2 mt-lg-0">
                <VueMultiselect v-model="filters.employees" :options="employees" :searchable="true" :multiple="true"
                    label="name" placeholder="Počet zaměstnanců" class="w-100 multiselect" track-by="id"
                    :select-label="$t('multiselect.pressToSelect')" :deselect-label="$t('multiselect.pressToDeselect')"
                    :selected-label="$t('multiselect.selected')" :limit="3" :limit-text="getLimitText"
                    :showNoResults="false">>
                </VueMultiselect>
            </div>
            <div class="col-12 col-lg-6 col-xl-4 mt-2 mt-xl-0">
                <VueMultiselect v-model="filters.trades" :options="trades" :searchable="true" :multiple="true"
                    group-label="name" group-values="data" label="name" placeholder="Živnosti" class="w-100 multiselect"
                    track-by="id" :select-label="$t('multiselect.pressToSelect')"
                    :deselect-label="$t('multiselect.pressToDeselect')" :selected-label="$t('multiselect.selected')"
                    :limit="3" :limit-text="getLimitText" :showNoResults="false">
                </VueMultiselect>
            </div>
            <div class="col-12 col-lg-6 col-xl-4 mt-2">
                <VueMultiselect v-model="filters.legalForms" :options="legalForms" :searchable="true" :multiple="true"
                    label="name" placeholder="Typ společnosti" class="w-100 multiselect" track-by="id"
                    :select-label="$t('multiselect.pressToSelect')" :deselect-label="$t('multiselect.pressToDeselect')"
                    :selected-label="$t('multiselect.selected')" :limit="3" :limit-text="getLimitText"
                    :showNoResults="false">
                </VueMultiselect>
            </div>
            <div class="col-12 col-lg-6 col-xl-4 mt-2">
                <VueMultiselect v-model="filters.tags" :options="tags" :searchable="true" :multiple="true" label="name"
                    placeholder="Štítky" class="w-100 multiselect" track-by="id"
                    :select-label="$t('multiselect.pressToSelect')" :deselect-label="$t('multiselect.pressToDeselect')"
                    :selected-label="$t('multiselect.selected')" :limit="3" :limit-text="getLimitText"
                    :showNoResults="false">
                </VueMultiselect>
            </div>
            <div class="col-12 col-lg-6 col-xl-4 mt-2">
                <VueMultiselect v-model="filters.creation_date" :options="dateOptions" :multiple="true"
                    placeholder="Datum založení" class="w-100 multiselect" label="label" track-by="id"
                    :select-label="$t('multiselect.pressToSelect')" :selected-label="$t('multiselect.selected')"
                    :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false" :limit="2"
                    :limit-text="getLimitText">
                </VueMultiselect>
            </div>
            <div class="col-12 col-lg-6 col-xl-4 mt-2">
                <VueMultiselect v-model="filters.expired" :options="expired" :multiple="true"
                    placeholder="Aktivní i zaniklé" class="w-100 multiselect" label="label" track-by="id"
                    :select-label="$t('multiselect.pressToSelect')" :selected-label="$t('multiselect.selected')"
                    :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false">
                </VueMultiselect>
            </div>
            <div class="col-12 col-lg-6 col-xl-4 mt-2">
                <VueMultiselect v-model="filters.user_in_contact" :limit="2" :options="users" :multiple="true"
                    placeholder="V kontaktu s" class="w-100 multiselect" label="name" track-by="id"
                    :select-label="$t('multiselect.pressToSelect')" :selected-label="$t('multiselect.selected')"
                    :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false"
                    :limit-text="getLimitText">
                </VueMultiselect>
            </div>
            <div class="col-12 col-lg-6 col-xl-4 mt-2 align-self-center">
                <!-- Button trigger modal -->
                <div class="address_toggle d-flex align-items-center" :class="{ 'highlighted': isAddressFilterActive }"
                    data-bs-toggle="modal" data-bs-target="#addressModal">
                    <span>{{ $t('company.searchCompanyByAddress') }}</span>
                </div>
                <!-- Modal -->
                <div class="modal fade" id="addressModal" tabindex="-1" aria-labelledby="addressModal"
                    aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered">
                        <div class="modal-content modal_wrapper">
                            <div class="border-0 mt-2 py-2">
                                <label class="modal-title title" id="addressModal">{{ $t('company.searchByAddress') }}
                                </label>
                            </div>
                            <div class="modal-body p-0">
                                <div class="modal_checkboxes">
                                    <div class="box1 px-4 py-3 d-flex align-items-center">
                                        <input type="checkbox" v-model="manualFilters.address.residence"
                                            class="form-check-input mt-0 me-2" id="residence">
                                        <label for="residence" class="form-label m-0">{{ $t('company.residence')
                                            }}</label>
                                    </div>
                                    <div class="box2 px-4 py-3 d-flex align-items-center">
                                        <input type="checkbox" v-model="manualFilters.address.branch"
                                            class="form-check-input mt-0 me-2" id="branch">
                                        <label for="branch" class="form-label m-0">{{ $t('company.branch') }}</label>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <label for="address" class="form-label title">{{ $t('company.searchAddress')
                                        }}</label>
                                    <input type="text" :placeholder="$t('general.writeAddress')"
                                        v-model="manualFilters.address.address" class="form-control address_input">
                                </div>
                                <div class="mt-3">
                                    <label for="region" class="form-label title">{{ $t('company.searchByRegion')
                                        }}</label>
                                    <VueMultiselect v-model="manualFilters.address.regions" :options="regions"
                                        placeholder="Kraje" class="w-100" label="name" track-by="id"
                                        :select-label="$t('multiselect.pressToSelect')"
                                        :selected-label="$t('multiselect.selected')"
                                        :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false"
                                        :multiple="true" @change="updateDistricts">
                                    </VueMultiselect>
                                </div>
                                <div class="mt-3" v-if="manualFilters.address.regions.length > 0">
                                    <label for="district" class="form-label">{{ $t('company.searchByDistrict')
                                        }}</label>
                                    <VueMultiselect v-model="manualFilters.address.districts"
                                        :options="availableDistricts" placeholder="Okresy" class="w-100" label="name"
                                        track-by="id" :select-label="$t('multiselect.pressToSelect')"
                                        :selected-label="$t('multiselect.selected')" :multiple="true"
                                        :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false">
                                    </VueMultiselect>
                                </div>
                                <!-- Circle location Search -->
                                <div class="mt-3">
                                    <label for="area" class="form-label title">{{ $t('company.searchByCircle')
                                        }}</label>
                                    <CompanyLocationSearch @Area="updateArea" @size="size" :clearArea="clearArea"
                                        @AreaCleared="clearArea = false" />
                                </div>
                            </div>
                            <div class="modal-footer d-flex justify-content-center gap-3 border-0">
                                <button type="button" class="btn btn_main" data-bs-dismiss="modal">
                                    <span>{{ $t('utils.close') }}</span>
                                </button>
                                <button type="button" class="btn btn_main" @click="applyFilters"
                                    data-bs-dismiss="modal">
                                    <icon icon="Search" class="search_icon me-2"></icon>
                                    <span>{{ $t('utils.search') }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- FILTRERS FOR MOBILE -->
        <div v-if="$store.state.isMobile">
            <!-- OPEN FILTER MODAL BUTTON -->
            <button class="btn btn_main w-100 py-3" data-bs-toggle="modal" data-bs-target="#filterModal">
                <span>{{ $t('general.filtration') }}</span>
            </button>
            <!-- FILTERING MODAL FOR MOBILE  -->
            <Popup :header="$t('general.filterCompanies')" :editable="false" id="filterModal"
                :showButton="mobileAddressFiltering ? true : false" @save-data="applyFilters"
                :button="$t('utils.submit')">
                <template #body>
                    <div v-if="!mobileAddressFiltering">
                        <div class="col-12 col-lg-6 col-xl-4 name_input">
                            <input v-model="filters.q" class="form-control name_input"
                                placeholder="Vyhledat podle názvu nebo IČO">
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4 mt-2 mt-lg-0">
                            <VueMultiselect v-model="filters.employees" :options="employees" :searchable="true"
                                :multiple="true" label="name" placeholder="Počet zaměstnanců" class="w-100 multiselect"
                                track-by="id" :select-label="$t('multiselect.pressToSelect')"
                                :deselect-label="$t('multiselect.pressToDeselect')"
                                :selected-label="$t('multiselect.selected')" :limit="3" :limit-text="getLimitText"
                                :showNoResults="false">>
                            </VueMultiselect>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4 mt-2 mt-xl-0">
                            <VueMultiselect v-model="filters.trades" :options="trades" :searchable="true"
                                :multiple="true" group-label="name" group-values="data" label="name"
                                placeholder="Živnosti" class="w-100 multiselect" track-by="id"
                                :select-label="$t('multiselect.pressToSelect')"
                                :deselect-label="$t('multiselect.pressToDeselect')"
                                :selected-label="$t('multiselect.selected')" :limit="3" :limit-text="getLimitText"
                                :showNoResults="false">
                            </VueMultiselect>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4 mt-2">
                            <VueMultiselect v-model="filters.legalForms" :options="legalForms" :searchable="true"
                                :multiple="true" label="name" placeholder="Typ společnosti" class="w-100 multiselect"
                                track-by="id" :select-label="$t('multiselect.pressToSelect')"
                                :deselect-label="$t('multiselect.pressToDeselect')"
                                :selected-label="$t('multiselect.selected')" :limit="3" :limit-text="getLimitText"
                                :showNoResults="false">
                            </VueMultiselect>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4 mt-2">
                            <VueMultiselect v-model="filters.tags" :options="tags" :searchable="true" :multiple="true"
                                label="name" placeholder="Štítky" class="w-100 multiselect" track-by="id"
                                :select-label="$t('multiselect.pressToSelect')"
                                :deselect-label="$t('multiselect.pressToDeselect')"
                                :selected-label="$t('multiselect.selected')" :limit="3" :limit-text="getLimitText"
                                :showNoResults="false">
                            </VueMultiselect>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4 mt-2">
                            <VueMultiselect v-model="filters.creation_date" :options="dateOptions" :multiple="true"
                                placeholder="Datum založení" class="w-100 multiselect" label="label" track-by="id"
                                :select-label="$t('multiselect.pressToSelect')"
                                :selected-label="$t('multiselect.selected')"
                                :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false" :limit="2"
                                :limit-text="getLimitText">
                            </VueMultiselect>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4 mt-2">
                            <VueMultiselect v-model="filters.expired" :options="expired" :multiple="true"
                                placeholder="Aktivní i zaniklé" class="w-100 multiselect" label="label" track-by="id"
                                :select-label="$t('multiselect.pressToSelect')"
                                :selected-label="$t('multiselect.selected')"
                                :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false">
                            </VueMultiselect>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4 mt-2">
                            <VueMultiselect v-model="filters.user_in_contact" :limit="2" :options="users"
                                :multiple="true" placeholder="V kontaktu s" class="w-100 multiselect" label="name"
                                track-by="id" :select-label="$t('multiselect.pressToSelect')"
                                :selected-label="$t('multiselect.selected')"
                                :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false"
                                :limit-text="getLimitText">
                            </VueMultiselect>
                        </div>
                        <!-- BUTTON FOR SWITCHING -->
                        <button v-if="!mobileAddressFiltering" class="btn btn_main w-100 mt-3" type="button"
                            @click="mobileAddressFiltering = true">
                            {{ $t('company.searchCompanyByAddress') }}
                        </button>
                    </div>
                    <!-- SEARCHING BY ADDRESS ON MOBILE -->
                    <div v-if="mobileAddressFiltering" class="">
                        <div>
                            <button class="btn btn_main w-100 mb-3" type="button"
                                @click="mobileAddressFiltering = false">
                                {{ $t('general.back') }}
                            </button>
                        </div>
                        <div class="border-0">

                        </div>
                        <div class="p-0">
                            <label class="form-label title px-3">{{ $t('company.searchByAddress')
                                }}</label>
                            <div class="modal_checkboxes">
                                <div class="box1 px-4 py-3 d-flex align-items-center">
                                    <input type="checkbox" v-model="manualFilters.address.residence"
                                        class="form-check-input mt-0 me-2" id="residence">
                                    <label for="residence" class="form-label m-0">{{ $t('company.residence')
                                        }}</label>
                                </div>
                                <div class="box2 px-4 py-3 d-flex align-items-center">
                                    <input type="checkbox" v-model="manualFilters.address.branch"
                                        class="form-check-input mt-0 me-2" id="branch">
                                    <label for="branch" class="form-label m-0">{{ $t('company.branch') }}</label>
                                </div>
                            </div>
                            <div class="mt-3">
                                <label for="branch" class="form-label title px-3">{{ $t('company.searchAddress')
                                    }}</label>
                                <input type="text" :placeholder="$t('general.writeAddress')"
                                    v-model="manualFilters.address.address" class="form-control address_input">
                            </div>
                            <div class="mt-3">
                                <label for="branch" class="form-label title px-3">{{ $t('company.searchByRegion')
                                    }}</label>
                                <VueMultiselect v-model="manualFilters.address.regions" :options="regions"
                                    placeholder="Kraje" class="w-100" label="name" track-by="id"
                                    :select-label="$t('multiselect.pressToSelect')"
                                    :selected-label="$t('multiselect.selected')"
                                    :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false"
                                    :multiple="true" @change="updateDistricts">
                                </VueMultiselect>
                            </div>
                            <div class="mt-3" v-if="manualFilters.address.regions.length > 0">
                                <label for="branch" class="form-label">{{ $t('company.searchByDistrict')
                                    }}</label>
                                <VueMultiselect v-model="manualFilters.address.districts" :options="availableDistricts"
                                    placeholder="Okresy" class="w-100" label="name" track-by="id"
                                    :select-label="$t('multiselect.pressToSelect')"
                                    :selected-label="$t('multiselect.selected')" :multiple="true"
                                    :deselect-label="$t('multiselect.pressToDeselect')" :showNoResults="false">
                                </VueMultiselect>
                            </div>
                            <!-- Circle location Search -->
                            <div class="mt-3">
                                <label for="branch" class="form-label title px-3">{{ $t('company.searchByCircle')
                                    }}</label>
                                <CompanyLocationSearch @Area="updateArea" @size="size" :clearArea="clearArea"
                                    @AreaCleared="clearArea = false" />
                            </div>
                        </div>
                    </div>
                </template>
            </Popup>
        </div>
        <!-- Clear filters -->
        <div v-if="showClearFilters()">
            <button class="btn clear_filters" @click="clearFilters()">{{ $t('utils.clearFilters') }}</button>
        </div>
        <div v-if="loading" class="loading-container mt-3">
            <div class="d-flex align-items-center justify-content-center flex-column">
                <SpinningWheel />
            </div>
        </div>
        <div v-else-if="!loading" class="table_container table-responsive mt-3">
            <table class="table table-hover mb-0" style="min-width: 1000px;">
                <thead class="table_head">
                    <tr>
                        <th class="col-2">{{ $t("company.companyName") }}</th>
                        <th class="col-1">{{ $t("company.organizationId") }}</th>
                        <th class="col-3">{{ $t("company.address") }}</th>
                        <th class="col-2" style="text-wrap: nowrap;">{{ $t("company.inContactWith") }}</th>
                        <th class="col-2">{{ $t("company.tags") }}</th>
                        <th class="col-1"></th>
                        <th class="col-1"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="company in companies" :key="company.slug" class="align-middle clickable">
                        <td class="col-2" @click="navigateToCompany(company.slug)">
                            <span v-if="company.name">{{ company.name }}</span>
                            <span v-else>---</span>
                        </td>
                        <td class="col-1" @click="navigateToCompany(company.slug)">
                            <span v-if="company.organization_id">{{ company.organization_id }}</span>
                            <span v-else>---</span>
                        </td>
                        <td class="col-3">
                            <span
                                v-if="company.residenceAddress && company.residenceAddress.whole_address && company.residenceAddress.uuid"
                                class="company_address_link">
                                <router-link v-if="!$store.getters.user.demo"
                                    :to="{ name: 'companiesSameAddress', params: { slug: company.residenceAddress.uuid } }"
                                    class="router_link">
                                    {{ company.residenceAddress.whole_address }}
                                </router-link>
                                <span v-else>
                                    {{ company.residenceAddress.whole_address }}
                                </span>
                            </span>
                            <span v-else>---</span>
                        </td>
                        <td class="col-2 p-0" @click="navigateToCompany(company.slug)">
                            <div class="d-flex align-items-center user_avatar">
                                <template v-if="company.in_contact_with && company.in_contact_with.length > 0"
                                    class="user_avatar">
                                    <UserAvatar v-for="user in company.in_contact_with" :key="user.id" :user="user"
                                        :user_role="user.role || null" class="me-2 user_avatar" />
                                </template>
                                <span v-else>---</span>
                            </div>
                        </td>
                        <td class="col-2" @click="navigateToCompany(company.slug)">
                            <div class="d-flex flex-wrap gap-1">
                                <span v-if="company.tags.length === 0" class="text-muted">{{ $t('company.noTag')
                                    }}</span>
                                <template v-else>
                                    <span v-for="(tag, index) in company.tags.slice(0, 3)" :key="index">
                                        <Tag :color="tag.color" :bg="tag.bg_color" :text="tag.name"
                                            :showDeleteButton="false" />
                                    </span>
                                    <span v-if="company.tags.length > 3" class="badge bg-secondary">
                                        +{{ company.tags.length - 3 }}
                                    </span>
                                </template>
                            </div>
                        </td>
                        <td class="col-1">
                            <div class="d-flex flex-wrap gap-1">
                                <div v-if="company.any_documents">
                                    <IconFileCheck stroke-width="1.5" width="33" height="33" style="stroke: black;"
                                        class="file_icon" />
                                    <span class="hover-text">{{ $t("general.hasDocument") }}</span>
                                </div>
                                <div v-if="company.any_contacts">
                                    <IconPhone stroke-width="1.5" width="33" height="33" style="stroke: black;"
                                        class="contact_icon" />
                                    <span class="hover-text">{{ $t("general.hasEvent") }}</span>

                                </div>
                                <div v-if="company.any_events">
                                    <IconCalendarEvent stroke-width="1.5" width="33" height="33" style="stroke: black;"
                                        class="event_icon" />
                                    <span class="hover-text">{{ $t("general.hasContact") }}</span>
                                </div>
                            </div>
                        </td>
                        <td class="col-1 text-end pe-4" @click="navigateToCompany(company.slug)">
                            <router-link :to="{ name: 'company', params: { slug: company.slug } }"
                                class="btn btn-primary button_detail p-0">
                                <icon icon="Info"></icon>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="loading-container" style="max-height: 200px; min-height: 200px;" v-if="companies && companies.length == 0">
                <span>{{ $t("general.companiesNotFound") }}</span>
            </div>
        </div>
    </div>
    <div v-if="error">
        <CompaniesNotPaidError :error="error" />
    </div>

    <div v-if="!error && !loading" class="row justify-content-between page_counter mx-1">
        <Paginator v-model:page="filters.page" :pages="Math.ceil(totalCount / filters.per_page)" class="col-auto " />
        <div class="col-auto page_number d-flex">
            <select v-model="filters.per_page" class="form-select align-self-center h-100" ref="perPageSelect">
                <option v-for="page in perPage" :key="page" :value="page" class="">
                    <span class="">{{ page }}</span>
                </option>
            </select>
            <icon icon="ArrowUp" class="arrow_up_icon my-auto" @click="openSelect"></icon>
        </div>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect';
import Paginator from '@/components/Paginator.vue';
import SpinningWheel from '@/components/SpinningWheel.vue';
import UserAvatar from "@/components/CompanyDetail/UserAvatar.vue";
import Tag from '@/components/Tag.vue';
import { mapGetters, mapActions } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
import CompaniesNotPaidError from '@/components/CompaniesNotPaidError.vue';
import CompanyLocationSearch from '@/components/CompanyLocationSearch.vue';
import Popup from '@/components/Popup.vue';
import { IconFileCheck } from '@tabler/icons-vue';
import { IconPhone } from '@tabler/icons-vue';
import { IconCalendarEvent } from '@tabler/icons-vue';

export default {
    components: {
        VueMultiselect,
        Paginator,
        SpinningWheel,
        Tag,
        UserAvatar,
        BaseTemplate,
        LanguageSelector,
        CompaniesNotPaidError,
        CompanyLocationSearch,
        Popup,
        IconFileCheck,
        IconPhone,
        IconCalendarEvent
    },
    data() {
        return {
            companies: [],
            totalCount: 0,
            employees: [],
            trades: [],
            legalForms: [],
            tags: [],
            perPage: [
                1, 5, 10, 20, 50, 100
            ],
            loading: false,
            debouce: 700,
            timeout: null,
            dateOptions: [
                { id: 'last7', label: this.$t('general.last7Days') },
                { id: 'last30', label: this.$t('general.last30Days') },
                { id: 'last90', label: this.$t('general.last90Days') },
                { id: 'last365', label: this.$t('general.last365Days') }
            ],
            expired: [
                { id: 'false', label: this.$t('general.active') },
                { id: 'true', label: this.$t('general.expired') }
            ],
            users: [],
            error: false,
            regions: [],
            availableDistricts: [],
            currentPage: null,
            mobileAddressFiltering: false,
            clearArea: false
        }
    },
    computed: {
        ...mapGetters(['filters']), // Map Vuex getters
        manualFilters: {
            get() {
                return this.$store.getters.manualFilters;
            },
            set(value) {
                this.$store.commit('setManualFilters', value);
            }
        },
        userName() {
            return this.users.map(user => {
                return {
                    ...user,
                    displayName: user.name || user.username
                }
            })
        },
        updateDistricts: function () {
            if (this.manualFilters.address.regions && this.manualFilters.address.regions.length > 0) {
                var activeRegions = this.manualFilters.address.regions;

                this.availableDistricts = activeRegions.flatMap(region => region.districts);

            } else {
                this.availableDistricts = [];
            }
            // If no region is selected, then no disctrict is selected also
            if (!this.manualFilters.address.regions || this.manualFilters.address.regions.length === 0) {
                this.manualFilters.address.districts = [];
            }

        },
        isAddressFilterActive() {
            return (
                this.manualFilters.address.residence ||
                this.manualFilters.address.branch ||
                (this.manualFilters.address.address && this.manualFilters.address.address.trim() !== '') ||
                (this.manualFilters.address.regions && this.manualFilters.address.regions.length > 0) ||
                (this.manualFilters.address.districts && this.manualFilters.address.districts.length > 0)
            );
        },
    },
    created: function () {
        this.loadData();
    },
    watch: {
        filters: {
            handler(newFilters, oldFilters) {
                if (!oldFilters) {
                    this.currentPage = newFilters.page || 1;
                    this.loadCompanies();
                    return;
                }

                if (newFilters.page !== oldFilters.page) {
                    this.currentPage = newFilters.page;
                } else {
                    const keys = Object.keys(newFilters).filter(key => key !== 'page' && key !== 'per_page');
                    let otherChanged = false;
                    for (let key of keys) {
                        if (newFilters[key] !== oldFilters[key]) {
                            otherChanged = true;
                            break;
                        }
                    }
                    if (otherChanged) {
                        if (newFilters.page !== 1) {
                            this.updateFilters({ ...newFilters, page: 1 });
                        }
                        this.currentPage = 1;
                    }
                }

                this.loadCompanies();
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        ...mapActions(['updateFilters']), // Map Vuex actions
        loadData: function () {
            this.loadCompanies();

            this.$store.getters.api.get('/employees').then(function (response) {
                this.employees = response.data.items;
            }.bind(this))

            this.$store.getters.api.get('/trades').then(function (response) {
                this.trades = response.data.items;
            }.bind(this))

            this.$store.getters.api.get('/legal_forms').then(function (response) {
                this.legalForms = response.data.items;
            }.bind(this))

            this.$store.getters.api.get('/regions').then(function (response) {
                this.regions = response.data.regions;
            }.bind(this))

            this.$store.getters.api.get(`institution/${this.$store.getters.selectedInstitution}/tags`).then(function (response) {
                this.tags = [{ id: 'no_tag', name: this.$t('company.noTag') }, ...response.data.items];
            }.bind(this))
            this.$store.getters.api.get(`institution/${this.$store.getters.selectedInstitution}/users`).then(function (response) {
                this.users = [{ id: 'no_user', name: this.$t('company.noUser') }, ...response.data.items];
            }.bind(this))

        },
        loadCompanies: function () {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(function () {
                var params = {
                    ...this.filters
                };
                if (params.creation_date) {
                    var creation_date = [];
                    params.creation_date.forEach(element => {
                        creation_date.push(element.id);
                    })
                    params.creation_date = creation_date;
                }

                if (params.expired) {
                    var expired = [];
                    params.expired.forEach(element => {
                        expired.push(element.id);
                    })
                    params.expired = expired;
                }
                if (params.user_in_contact) {
                    var users = []
                    params.user_in_contact.forEach(element => {
                        if (element.id === 'no_user') {
                            params.no_user = true;
                            params.user_in_contact = null;
                        }
                        else {
                            params.no_user = false;
                            users.push(element.id)
                        }
                    });
                    params["users_in_contact"] = users
                }

                if (params.employees) {
                    var employees = []
                    params.employees.forEach(element => {
                        employees.push(element.id);
                    });
                    params.employees = employees;
                }

                if (params.trades) {
                    var trades = []
                    params.trades.forEach(element => {
                        trades.push(element.id);
                    });
                    params.trades = trades;
                }

                if (params.legalForms) {
                    var legalForms = []
                    params.legalForms.forEach(element => {
                        legalForms.push(element.id);
                    });
                    params.legalForms = legalForms;
                }

                if (params.tags) {
                    var tags = [];
                    params.tags.forEach(element => {
                        if (element.id !== 'no_tag') {
                            tags.push(element.id);
                        }
                        else {
                            tags.push('no_tag');
                            params.no_tag = true;
                        }
                    });
                    params.tags = tags;
                }

                this.loading = true;
                this.error = false
                var urlParams = ""
                if (params.page || params.per_page) {
                    urlParams = "?"
                    if (params.page && params.per_page) {
                        urlParams += "page=" + params.page + "&per_page=" + params.per_page
                    }
                    else if (params.page) {
                        urlParams += "page=" + params.page
                    }
                    else if (params.per_page) {
                        urlParams += "per_page=" + params.per_page
                    }
                }
                this.$store.getters.api.post('/companies' + urlParams, params).then(function (response) {
                    const data = response.data;
                    this.companies = response.data.results;
                    this.totalCount = response.data.count;
                    this.loading = false;

                    if (data.error_code == 401) {
                        this.error = (this.$t("error.401"));
                    }

                }.bind(this))
                    // Prevents from staying on invalid page after changing filters
                    .catch(function (error) {
                        if (error.response.data.detail === "Invalid page.") {
                            this.currentPage = 1;
                            this.filters.page = 1
                            this.loadCompanies();
                        }
                    }.bind(this));
            }.bind(this), this.debouce);
        },
        applyFilters() {
            this.$store.commit('setManualFilters', this.manualFilters);
            const combinedFilters = { ...this.filters, address: this.manualFilters.address };
            this.updateFilters(combinedFilters);
            this.loadCompanies();
        },
        getLimitText(count) {
            return this.$t('multiselect.andMore', { count });
        },
        showClearFilters: function () {
            if (
                (this.filters.q?.length > 0) ||
                (this.filters.employees?.length > 0) ||
                (this.filters.trades?.length > 0) ||
                (this.filters.legalForms?.length > 0) ||
                (this.filters.tags?.length > 0) ||
                (this.filters.creation_date?.length > 0) ||
                (this.filters.expired?.length > 0) ||
                (this.filters.user_in_contact?.length > 0) ||
                (this.filters.address?.residence || this.filters.address?.branch || this.filters.address?.address) ||
                (this.filters.address?.regions?.length > 0 || this.filters.address?.districts?.length > 0) ||
                (this.filters.address?.area)
            ) {
                return true;
            }
            return false;
        },
        clearFilters() {
            this.$store.commit('updateFilters', {
                per_page: 10,
                page: 1,
                creation_date: null,
                expired: null,
                employees: [],
                trades: [],
                legalForms: [],
                tags: [],
                user_in_contact: null,
            });

            this.$store.commit('setManualFilters', {
                address: {
                    residence: false,
                    branch: false,
                    address: '',
                    regions: [],
                    districts: [],
                    area: null
                }
            });
            this.clearArea = true
            this.loadCompanies();
        },
        navigateToCompany(slug) {
            this.$router.push({ name: 'company', params: { slug: slug } });
        },
        updateArea(area) {
            this.$store.commit('setManualFilters', {
                address: {
                    ...this.manualFilters.address,
                    area: area
                }
            });
            this.loadCompanies();
        },
        openSelect() {
            // Focus on the select to open the dropdown
            this.$refs.perPageSelect.focus();
            // On some browsers, focusing is enough to open the native dropdown.
            // If not, this triggers a click programmatically:
            this.$refs.perPageSelect.click();
        }
    },
}
</script>


<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.name_input {
    border-radius: 65px !important;
    color: $dark-grey;
    height: 50px;

    input:focus {
        padding-left: 25px;
    }
}

.name_input::placeholder {
    color: $black;
    opacity: 0.9;
    font-size: 18px;
    font-weight: 400;
    padding: 8px;
}

.clickable {
    :hover {
        cursor: pointer;
    }
}

.company_address_link {
    .router_link {
        text-decoration: none;
        color: $dark-grey;
        font-weight: 400;
    }

    .router_link:hover {
        text-decoration: underline;
        font-weight: 500;
    }
}

::v-deep .multiselect,
::v-deep .multiselect__tags {
    border-radius: 65px !important;
}

.address_toggle {
    background-color: $white;
    color: $dark-grey;
    border-radius: 65px;
    height: 50px;
    cursor: pointer;

    span {
        padding: 20px;
        font-size: 18px;
        font-weight: 400;
    }
}

.highlighted {
    background-color: $purple;
    color: $white;
    transition: background-color 0.3s ease-in-out;
}


.modal_wrapper {
    border-radius: 65px;
    padding: 10px 25px 10px 25px;
    color: $white;

    .modal_checkboxes {
        color: $black;
        background-color: $white;
        border-radius: 35px;
        font-size: 18px;

        input {
            cursor: pointer;
            border-radius: 50px;
            border: 2px solid $dark-purple;
            width: 28px;
            height: 28px;
        }

        .form-check-input:checked {
            background-color: $dark-purple;
        }

        .box2 {
            color: $black;
            background-color: $grey;
            border-radius: 35px;
        }
    }

    .address_input {
        border-radius: 35px;
        padding: 10px 10px 60px 20px;
    }

    .search_icon {
        color: $white;
        stroke: $white;
    }

    label {
        font-size: 20px;

        @media (max-width:850px) {
            font-size: 18px;
        }
    }
}

.clear_filters {
    color: $white;
    background-color: transparent;
    font-weight: 700;
    text-decoration: underline;
}

.button_detail {
    border: none;
    background-color: transparent;

    svg {
        width: 42px;
        height: 42px;
    }
}

.button_detail:hover {
    background: transparent;
    border: none;

}

.button_detail:focus {
    background: none;
    border: none;
}

.loading-container {
    min-height: 500px;
    /* Minimum height to prevent layout shift */
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;

    span {
        color: black;
    }
}

.hover-text {
    display: none;
    position: absolute;
    background-color: $white;
    padding: 5px;
    border: 1px solid $primary;
    z-index: 1;
    font-size: 16px;
}

.file_icon:hover+.hover-text,
.contact_icon:hover+.hover-text,
.event_icon:hover+.hover-text {
    display: block;
}

@media (max-width: 650px) {
    .paginator {
        margin-top: 10px;
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .page_number {
        width: 100%;
        max-width: 200px;
        margin-top: 10px;
        margin-right: auto !important;
        margin-left: auto !important;
    }
}
</style>